import { format } from 'date-fns';

/**
 * 
 * @param {string} isoDateString 
 * @param {string} [dateFormat='M/d/yyyy']
 * @returns {string}
 */
const formatDate = (isoDateString, dateFormat = 'M/d/yyyy') => {
    return format(new Date(isoDateString), dateFormat);
};

/**
 * 
 * @param {string} isoDateString
 * @param {string} [timeFormat='h:mm:ss a']
 * @returns {string}
 */
const formatTime = (isoDateString, timeFormat = 'h:mm:ss a') => {
    return format(new Date(isoDateString), timeFormat);
};

export { formatDate, formatTime };
